import { observer } from 'mobx-react';
import { DelinquencyBpoDashboards } from './DelinquencyBpoDashboards';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type DelinquencyBpoDashboardsItemProps = {
  open: boolean;
  onClose: () => void;
  loanId: string | number;
  document?: DocumentType;
  isInternal?: boolean;
  isTamariskLender?: boolean;
};

export const DelinquencyBpoDashboardsItem = observer(
  ({
    open,
    onClose,
    loanId,
    document,
    isInternal = true,
    isTamariskLender = false,
  }: DelinquencyBpoDashboardsItemProps) => {
    const loanIdNum = typeof loanId === 'string' ? Number(loanId) : loanId;

    const dialogContent = (
      <DelinquencyBpoDashboards
        loanId={loanIdNum}
        isInternal={isInternal}
        isTamariskLender={isTamariskLender}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Property Valuations"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Property Valuations"
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default DelinquencyBpoDashboardsItem;
